const amount = (value) => (Number.isFinite(value) ? Math.max(0, value) : 0);

export const getTotalShardsAcquired = (game) => {
  if (Number.isFinite(game.totalShardsAcquired))
    return Math.max(amount(game.totalShardsAcquired), amount(game.shards));
  // Old saves only retain a short reward history. Seed the counter from the
  // known lower bound; never invent an amount for purchases that weren't saved.
  const history = game.history || [];
  const rewards = history.length ? history : [game.lastResult].filter(Boolean);
  return Math.max(
    amount(game.shards),
    rewards.reduce(
      (sum, entry) => sum + amount(entry.earned ?? entry.loot?.shards),
      0
    )
  );
};

export const acquireShards = (game, earned) =>
  getTotalShardsAcquired(game) + amount(earned);
